// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2QmR_","modalFooterButton":"ModalNotes_modalFooterButton__blh3p"};